import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";

import ItemGroupsActions from "../../../store/actions/items/categories/itemGroups/itemGroups.actions";
import { categoryModel } from "../../../models/items/categories/category.model";

export const AddCategoryPageComponent = ({categoryActions}) => {
  const defaultCredentials = { email: "", password: "" };
  const [categoryDetails, setCategoryDetails] = useState(categoryModel);
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCategoryDetails({ ...categoryDetails, [name]: value });
  };

  const handleAddCategory = async (event) => {
    event.preventDefault(); // Prevent default form submission
    try {
      const response = await categoryActions.addCategory(categoryDetails);
    } catch (error) {}
  };

  return (
    <div>
      <form onSubmit={handleAddCategory}>
        <input type="text" placeholder="enter categoryName" name="categoryName" value={categoryDetails.categoryName} onChange={handleInputChange} />
        <input type="text" placeholder="enter description" name="description" value={categoryDetails.description} onChange={handleInputChange} />
        <button onClick={handleAddCategory}>Add Category</button>
      </form>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  categoryReducer: state.categoryReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(ItemGroupsActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCategoryPageComponent);
